export const isFavoriteSpace = (
  spaceId: number,
  favoriteSpaces: number[],
): boolean => {
  if (!favoriteSpaces) {
    return false
  }

  const spaces = [...favoriteSpaces]
  return spaces.some((id) => id === spaceId)
}
